import { useList } from "../../list";

export const useListCurrencies = ({ params = {} }) => {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'currencies',
    { ...params },
    '',
    'v1'
  );

  return {
    currencyList: data?.data?.data,
    count: data?.data?.data?.length,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
}